export default __webpack_public_path__ + "static/media/030-cabbage.1a48c920.svg";